export { default } from "./Contact";



// WEBPACK FOOTER //
// ./src/components/Contact/index.js